import React, { useState, useEffect } from "react";
import { Input, Form, Select, Checkbox } from "antd";
import LoadableButton from '../../../components/buttons/LoadableButton';
import toast from "react-hot-toast";
import { AddVerifyuser, GetAllgroupApi, GetAllPlanApi } from "../../../api/request/accountVerify";
import { useSelector, useDispatch } from 'react-redux';
import { CheckKycStatusApi } from '../../../api/request/kyc';
import { useNavigate } from 'react-router-dom';
import { setUserDetails } from "../../../store/slices/userSlice.js";

function AccountVerify() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state.user);
    const [form] = Form.useForm();
    const [isAddLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState();
    const [acPlan, setAcPlan] = useState([]);
    const [leverageOptions, setLeverageOptions] = useState([{ value: 20, label: '20' }, { value: 50, label: '50' }, { value: 100, label: '100' }, { value: 200, label: '200' }, { value: 300, label: '300' }, { value: 400, label: '400' }, { value: 500, label: '500' }]);


    const checStatus = async () => {
        try {
            let params = {
                UserId: userDetails?.id
            }
            const { data } = await CheckKycStatusApi(new URLSearchParams(params).toString());
            if (data?.success) {
                dispatch(setUserDetails({ ...userDetails, clientVerify: data?.data?.clientVerify, status: data?.data?.status, kycStatus: data?.data?.kycStatus }));

                if (data?.data?.clientVerify === true) {
                    navigate('/dashboard');
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            }
        } catch (error) { }
    }

    const handleSubmit = async (value) => {
        try {
            setIsLoading(true);
            let params = {
                userId: userDetails?.id,
                username: value.username,
                password: value.password,
                investorPassword: value.investorPassword,
                readOnlyLogin: value.readOnlyLogin === true ? true : false,
                forceChangePassword: value.forceChangePassword === true ? true : false,
                leverage: `1:${value.leverage}`,
                groupId: value.groupId,
            }
            const { data } = await AddVerifyuser(params);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                checStatus()
                setIsLoading(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsLoading(false);
        }
    }

    const getAccountPlan = async () => {
        try {
            const { data } = await GetAllPlanApi();
            if (data?.success) {
                setAcPlan(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.name })));
            }
        } catch (error) { }
    }

    useEffect(() => {
        getAccountPlan();
    }, []);

    const filterOption = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }
    return (
        <div className='border-[2px] border-light rounded-xl p-4 lg:p-6 w-full mt-5'>
            <Form
                className="w-full"
                autoComplete="off"
                form={form}
                initialValues={initialValues}
                onFinish={handleSubmit}
            >
                <div className="grid sm:grid-cols-3 lg:grid-cols-3 gap-5">
                    <div className="input-white">
                        <label className="text-base text-[#2F2B3DCC] font-medium">
                            User name
                        </label>
                        <Form.Item name="username" rules={[{ required: true, message: "Please enter user name." }]}>
                            <Input placeholder="User name" className="mt-1 w-full py-2" />
                        </Form.Item>
                    </div>
                    <div className='ant-select-selector-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
                        <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
                            <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
                        </Form.Item>
                    </div>
                    <div className="ant-select-selector-white">
                        <p className="text-base text-[#2F2B3DCC] font-medium">Select AccountType</p>
                        <Form.Item name="groupId" rules={[{ required: true, message: 'Please select account.' }]}>
                            <Select className="mt-1" showSearch filterOption={filterOption} options={acPlan} placeholder='Select a account' />
                        </Form.Item>
                    </div>
                    <div className='input-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Password</label>
                        <Form.Item name='password' hasFeedback rules={[{ required: true, message: 'Please enter new password.' }, {
                            pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                            message: 'Please enter strong password.',
                        },]}>
                            <Input.Password type='password' placeholder="password" className="mt-1 w-full ps-4 py-2" />
                        </Form.Item>
                    </div>
                    <div className='input-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Investor Password</label>
                        <Form.Item name='investorPassword' dependencies={['investorPassword']} hasFeedback rules={[{ required: true, message: 'Please enter password.' }, {
                            pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                            message: 'Please enter strong investor password.',
                        },]}>
                            <Input.Password type='password' placeholder="Investor Password" className="mt-1 w-full ps-4 py-2" />
                        </Form.Item>
                    </div>

                    {/* <div className="ant-select-selector-white mt-8">
                        <div className="flex">
                            <div className="flex">
                                <Form.Item name="readOnlyLogin" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                                <p className="text-base text-[#2F2B3DCC] font-medium ml-2 mt-1">Read Only</p>
                            </div>
                            <div className="flex ml-4">
                                <Form.Item name="forceChangePassword" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                                <p className="text-base text-[#2F2B3DCC] font-medium ml-2 mt-1">Force Change Password</p>
                            </div>
                        </div>
                    </div> */}

                </div>
                <div className="flex justify-end mt-8">
                    <LoadableButton
                        className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                        disabled={isAddLoading}
                        type="Submit"
                        lable="Submit"
                        isLoading={isAddLoading}
                        loadingLable="Account Verify..."
                    />
                </div>
            </Form>
        </div>
    )
}

export default AccountVerify